import { Component, type OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { ContactService } from 'src/app/shared/store/contact/contact.service';
import {
  ContactDetailModel,
  ContactModel,
} from 'src/app/shared/store/contact/types';

@Component({
  selector: 'app-contact-details-referees',
  templateUrl: './contact-details-referees.component.html',
  styleUrls: ['./contact-details-referees.component.scss'],
  standalone: false,
})
export class ContactDetailsRefereesComponent implements OnInit {
  contactDetail$: Observable<ContactDetailModel>;

  constructor(private readonly contactService: ContactService) {}

  ngOnInit(): void {
    this.contactDetail$ = this.contactService.getById.value$;
  }
}
